import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba5c55a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title pt-5" }, "مستندات وب هوک")
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " وب‌هوک‌ها برای ارتباط و اطلاع‌رسانی بین برنامه‌ها و سرویس‌های مختلف استفاده می‌شوند. مثال‌های ی از استفاده از وب‌هوک‌ها شامل اطلاع‌رسانی در صورت وقوع ارسال پیام انبوه یا نوتیفیکیشن به یک کاربر خاص، اطلاع از پیام دادن یک نفر به شماره شما و یا رویداد متوقف شدن اشتراک‌های شما می باشد. ایونت‌های قابل تعریف در وب هوک اینباکسینو در چهار حالت، پیام انبوه، پاسخگوی خودکار، اعلان و متوقف شدن اشتراک‌های کاربر قابل دسترسی می‌باشد. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "نمونه دیتای ارسالی پیام انبوه و اعلان", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " این رویداد زمانی فراخوانی می‌شود که یک پیام یا اعلان با موفقیت به مخاطب شما ارسال یا به علت نا معتبر بودن شماره یا خطاهای دیگر ارسال انجام نمی‌گردد. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", null, "            {\n              \"message_id\": 15246954,\n              \"bot_id\": \"wa-12548\",\n              \"status\": \"sent\",\n              \"error\": \"Error message\",\n              \"recipient\":\n              {\n                \"number\": \"+989960767790\",\n                \"avatar\": \"Avatar url\"\n              }\n            }\n          ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "نمونه دیتای ارسالی پاسخگوی خودکار", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " این رویداد زمانی فراخوانی می‌گردد که یک فرد به شماره شما پیام ارسال کند. توجه داشته باشید که رخ دادن این رویداد نیازمند این است که پاسخگوی خودکار فعال باشد. ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", null, "            {\n              \"bot_id\": \"wa-12548\",\n              \"message\": \"The user message\",\n              \"platform\": \"whatsapp\",\n              \"response\": \"Inboxino response text\",\n              \"chat\":\n              {\n                \"number\": \"+989960767790\",\n                \"avatar\": \"Avatar url\"\n              }\n            }\n          ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "نمونه دیتای ارسالی توقف اشتراک", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " این رویداد زمانی فراخوانی می‌شود که یکی از اشتراک‌های شما در اینباکسینو متوقف می‌گردد. ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", null, "            {\n              \"bot_id\": \"wa-12548\",\n              \"type\": \"need_login\"\n            }\n          ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_code_highlighter = _resolveComponent("code-highlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      class: "form",
      id: "kt_layout_builder_form",
      onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit($event)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_code_highlighter, null, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _hoisted_8,
        _hoisted_9,
        _createVNode(_component_code_highlighter, null, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _hoisted_11,
        _hoisted_12,
        _createVNode(_component_code_highlighter, null, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ])
    ], 32)
  ]))
}